import { PowerPerformanceRankDataType } from '../types/mutual-fund-detail.types'

export const powerPerformanceRankData: PowerPerformanceRankDataType = {
  responseType: 'MUTUAL_FUND_L2',
  responseName: 'MUTUAL_FUND_L2',
  userInvestmentType: 'NONE',
  eliteMemberShipStatus: 'ELITE',
  isFirstTimeElite: false,
  isPowerRankAvailable: true,
  performanceRankList: [
    {
      x_value: 1667260800000,
      y_value: 'IN_FORM',
      label: 100
    },
    {
      x_value: 1669852800000,
      y_value: 'ON_TRACK',
      label: 96
    },
    {
      x_value: 1672531200000,
      y_value: 'OFF_TRACK',
      label: 92
    },
    {
      x_value: 1675209600000,
      y_value: 'OUT_OF_FORM',
      label: 88
    },
    {
      x_value: 1677628800000,
      y_value: 'IN_FORM',
      label: 84
    },
    {
      x_value: 1680307200000,
      y_value: 'ON_TRACK',
      label: 80
    },
    {
      x_value: 1682899200000,
      y_value: 'OFF_TRACK',
      label: 76
    },
    {
      x_value: 1685577600000,
      y_value: 'OUT_OF_FORM',
      label: 72
    },
    {
      x_value: 1688169600000,
      y_value: 'IN_FORM',
      label: 68
    },
    {
      x_value: 1690848000000,
      y_value: 'ON_TRACK',
      label: 64
    },
    {
      x_value: 1693526400000,
      y_value: 'OFF_TRACK',
      label: 60
    },
    {
      x_value: 1696118400000,
      y_value: 'OUT_OF_FORM',
      label: 56
    },
    {
      x_value: 1698796800000,
      y_value: 'OUT_OF_FORM',
      label: 52
    },
    {
      x_value: 1701388800000,
      y_value: 'ON_TRACK',
      label: 48
    }
    // {
    //   x_value: 1704067200000,
    //   y_value: 'OFF_TRACK',
    //   label: 44
    // },
    // {
    //   x_value: 1706745600000,
    //   y_value: 'OUT_OF_FORM',
    //   label: 40
    // },
    // {
    //   x_value: 1709337600000,
    //   y_value: 'IN_FORM',
    //   label: 36
    // }
    // {
    //   x_value: 1712016000000,
    //   y_value: 'ON_TRACK',
    //   label: 32
    // },
    // {
    //   x_value: 1714608000000,
    //   y_value: 'OFF_TRACK',
    //   label: 28
    // },
    // {
    //   x_value: 1717286400000,
    //   y_value: 'OUT_OF_FORM',
    //   label: 24
    // },
    // {
    //   x_value: 1719878400000,
    //   y_value: 'IN_FORM',
    //   label: 20
    // },
    // {
    //   x_value: 1722556800000,
    //   y_value: 'ON_TRACK',
    //   label: 16
    // },
    // {
    //   x_value: 1725235200000,
    //   y_value: 'OFF_TRACK',
    //   label: 12
    // }
    // {
    //   x_value: 1727827200000,
    //   y_value: 'OUT_OF_FORM',
    //   label: 8
    // },
    // {
    //   x_value: 1730419200000,
    //   y_value: 'OUT_OF_FORM',
    //   label: 4
    // }
  ]
}
